// extracted by mini-css-extract-plugin
module.exports = {"mbnWrapper":"Mbn_mbnWrapper__2g8ov","mbn":"Mbn_mbn__19xvs","statistics":"Mbn_statistics__3MSia"};